import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    accessGroupList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    accessGroupDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const accessGroupSlice = createSlice({
  name: 'accessGroup',
  initialState,
  reducers: {
    getAccessGroupList: (state, action) => {
        state.accessGroupList.requesting = true;
        state.accessGroupList.error = null;
        state.accessGroupList.items = [];
        state.accessGroupList.success = false;
        state.accessGroupList.filters = action.payload;
    },
    getAccessGroupListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.accessGroupList.requesting = false;        
        state.accessGroupList.items = data;
        state.accessGroupList.success = true; 
        state.accessGroupList.pagination.current_page = current_page;
        state.accessGroupList.pagination.per_page = per_page;
        state.accessGroupList.pagination.total = total;
    },
    getAccessGroupListFail: (state, action) => {        
        state.accessGroupList.requesting = false;
        state.accessGroupList.error = action.payload;
    },
    getAccessGroupDetails: (state) => {
        state.accessGroupDetails.requesting = true;
        state.accessGroupDetails.error = null;
        state.accessGroupDetails.data = null;
        state.accessGroupDetails.success = false; 
    },
    getAccessGroupDetailsSuccess: (state, action) => {
        state.accessGroupDetails.requesting = false;
        state.accessGroupDetails.data = action.payload;
        console.log(action);
        state.accessGroupDetails.success = true; 
    },
    getAccessGroupDetailsFail: (state, action) => {        
        state.accessGroupDetails.requesting = false;
        state.accessGroupDetails.error = action.payload;
    },
    doAccessGroupCreate: (state) => {
        state.accessGroupDetails.requesting = true;
        state.accessGroupDetails.error = null;
        state.accessGroupDetails.data = null;
        state.accessGroupDetails.success = false; 
    },
    doAccessGroupUpdate: (state) => {
        state.accessGroupDetails.requesting = true;
        state.accessGroupDetails.error = null;
        state.accessGroupDetails.data = null;
        state.accessGroupDetails.success = false; 
    },
    doAccessGroupDelete: (state) => {
        state.accessGroupDetails.requesting = true;
        state.accessGroupDetails.error = null;
        state.accessGroupDetails.data = null;
        state.accessGroupDetails.success = false; 
    },
  },
})

export const { 
    getAccessGroupList, getAccessGroupListSuccess, getAccessGroupListFail,
    getAccessGroupDetails, getAccessGroupDetailsSuccess, getAccessGroupDetailsFail,
    doAccessGroupCreate, doAccessGroupUpdate, doAccessGroupDelete
} = accessGroupSlice.actions

export default accessGroupSlice.reducer